"use client";

import { AlertCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { formatPercent } from "@/lib/format";
import type { MetricValidation } from "@/lib/data/validation/types";

/** Zeigt nichts, solange eine Kennzahl "verified"/"single-source"/"unavailable" ist -
 * nur bei tatsaechlicher Abweichung zwischen zwei unabhaengigen Quellen (> 5 %, siehe
 * lib/config.ts -> DATA_VALIDATION) erscheint ein dezentes Hinweis-Badge. Rein
 * deskriptiv, keine Handlungssprache. */
export function DataQualityBadge({ validation }: { validation: MetricValidation | undefined }) {
  if (!validation || validation.status !== "unverified") return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label="Ungeprüft: Abweichung zwischen Datenquellen"
          onClick={(e) => e.stopPropagation()}
          className="inline-flex items-center gap-0.5 rounded-full border border-hairline px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground"
        >
          <AlertCircle className="h-2.5 w-2.5" />
          Ungeprüft
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        Weicht von einer zweiten, unabhängigen Datenquelle
        {validation.deviationPct !== undefined && Number.isFinite(validation.deviationPct)
          ? ` um ${formatPercent(validation.deviationPct)}`
          : ""}{" "}
        ab - Wert bitte mit Vorsicht einordnen.
      </TooltipContent>
    </Tooltip>
  );
}
